import styles from './ScoopMenu.module.scss'

/**
 * ScoopMenuDivider - Horizontal separator for menu sections
 *
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.style] - Inline styles for override
 */
export const ScoopMenuDivider = ({ className = '', style, ...props }) => {
    const dividerClassName = [styles.menuDivider, className].filter(Boolean).join(' ')

    return <div className={dividerClassName} role="separator" {...props} style={style} />
}

// This is useful for debugging and React DevTools
ScoopMenuDivider.displayName = 'ScoopMenuDivider'
